import React from 'react';
import { Moon, Sun } from 'lucide-react';
import { getNavMode, setNavMode } from '../../navigation/navPref';
import { useAuth } from '../../contexts/AuthContext';

// Bouton Mode jour / Mode nuit (remplace le choix entre les 3 navigations)
export const ModeJourNuit = ({ className = '' }) => {
  const { user, setUser } = useAuth();
  const nuit = getNavMode(user) === 'nuit';
  const Icon = nuit ? Sun : Moon;
  const label = nuit ? 'Mode jour' : 'Mode nuit';
  return (
    <button type="button" onClick={() => setNavMode(nuit ? 'jour' : 'nuit', user, setUser)}
      title={`Passer en ${label.toLowerCase()}`} aria-label={`Passer en ${label.toLowerCase()}`} aria-pressed={nuit}
      className={`opn-mode-btn inline-flex items-center gap-1.5 h-9 px-3 rounded-xl text-xs font-semibold transition-colors ${nuit ? 'text-amber-300 hover:bg-amber-400/15' : 'text-[#1173D4] hover:bg-[#EAF2FC]'} ${className}`}
      data-testid="mode-jour-nuit-btn">
      <Icon className="h-4 w-4" />
      <span className="hidden xl:inline">{label}</span>
    </button>
  );
};
